import { render, staticRenderFns } from "./table-widget.vue?vue&type=template&id=87b22432&scoped=true&"
import script from "./table-widget.vue?vue&type=script&lang=js&"
export * from "./table-widget.vue?vue&type=script&lang=js&"
import style0 from "./table-widget.vue?vue&type=style&index=0&id=87b22432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b22432",
  null
  
)

component.options.__file = "table-widget.vue"
export default component.exports